import { useEffect as n } from "react";
import { useApiUrl as c, useCustom as l } from "@refinedev/core";
const d = ({
  form: r,
  useCustomParams: i
}) => {
  const u = c(), t = l({
    url: `${u}/options`,
    // 預設 API 路徑
    method: "get",
    ...i
  }), { isFetching: s } = t;
  return n(() => {
    var e, o;
    if (!s) {
      const a = (o = (e = t.data) == null ? void 0 : e.data) == null ? void 0 : o.data;
      r.setFieldsValue(a);
    }
  }, [s]), t;
};
export {
  d as useOptions
};
